import UserOptBar from 'components/dot/bar/user-opt-bar/index';
import UserInfo from 'components/dot/user-info/index';
import React, { useContext, useEffect, useRef, useState } from 'react';

import UserCenter from './center/index';
import UserCollect from './collect/index';
import UserFeedback from './feedback/index';
import UserHistory from './history/index';
import UserSetting from './setting/index';

import { useQuery } from '@tanstack/react-query';
import { DotLoading, Swiper, SwiperRef } from 'antd-mobile';
import loading from 'antd-mobile/es/components/loading';
import { NavShowContext } from 'App';
import { ApiCachedSecondsRandom } from 'app/constant';
import img from 'app/img';
import { useI18n } from 'i18n/useI18n';
import { useNavigate } from 'react-router-dom';
import UserApi, { UserPolyInfoDT } from 'services/apis/sys/user-api';
import UserGroupApi, { UserGroupDataType } from 'services/apis/usr/user-group-api';
import { useImmer } from 'use-immer';
import { getBrowserFinger } from 'utils/browserFingerUtil';
import { date2DurationStr, localDatetime2Date } from 'utils/dateUtil';
import { setItemWithExpiration } from 'utils/localStorageUtil';
import Order from './order/index';

const Mine = () => {
  const { t } = useI18n();
  const [userPolyInfo, updateUserPolyInfo] = useImmer<UserPolyInfoDT>(null);
  // const [userGroupList, setUserGroupList] = useState<UserGroupDataType[]>([]);
  const swiperRef = useRef<SwiperRef>(null);
  const [activePanelIndex, setActivePanelIndex] = useState<number>(0);

  const updateNavShowState = useContext(NavShowContext).updateNavShowState;

  const userLevelMap: Map<string, UserGroupDataType> = new Map();
  const navigate = useNavigate();
  // const [loading, handleloading] = useState(true);

  // console.log('userPolyInfo', userPolyInfo);
  useEffect(() => {
    console.log('userPageIndex: ', activePanelIndex);
  }, [activePanelIndex]);

  // const fetchUser = async (userId: string) => {
  //   //获取用户详细信息
  //   const userDetailResult = await UserDetailApi.getByUserId(userId);
  //   if (userDetailResult.code === 0 && userDetailResult.successful) {
  //     //设置登录用户
  //     setItemWithExpiration(
  //       "vip",
  //       { userGroupId: userDetailResult.result?.fkUserGroupUuid || 0 },
  //       ApiCachedSecondsRandom
  //     );
  //     //获取用户组信息
  //     const userGroup = await UserGroupApi.get(userDetailResult.result.fkUserGroupUuid);
  //     if (userGroup.code === 0 && userGroup.successful) {
  //       const _userInfo = {
  //         user: user,
  //         userDetail: userDetailResult.result,
  //         userGroup: userGroup.result,
  //       };
  //       console.log("_userInfo", _userInfo);
  //       setUserPolyInfo(_userInfo);
  //       //TODO:查询用户角色
  //       //获取用户组列表
  //       const userGroupList = await UserGroupApi.list({} as unknown as UserGroupDataType);
  //       if (userGroupList.code === 0 && userGroupList.successful) {
  //         setUserGroupList(userGroupList.result);
  //         userGroupList.result.forEach((item: UserGroupDataType) => userLevelMap.set(item.uuid as string, item));
  //         setTimeout(() => {
  //           handleloading(false);
  //         }, 500);
  //         // console.log("userInfo", _userInfo);
  //         // console.log("userGroupList", userGroupList);
  //       }
  //     }
  //     //获取用户的视频列表(收藏列表和观看历史)
  //     listId = getItemWithExpiration("listId") as string[];
  //     // const result2 = await VideoListApi.getVideoListId(userId);
  //     // if (result2.code === 0 && result2.successful) {
  //     //   setItemWithExpiration("listId", result2.result, ApiCachedSecondsRandom);
  //     //   listId = getItemWithExpiration("listId") as string[];
  //     //   // console.log("用户:", getItemWithExpiration("user"));
  //     //   // console.log("视频列表:", getItemWithExpiration("listId"));
  //     // } else {
  //     //   Toast.show(t("login.index.863806-3"));
  //     // }
  //   }
  // };

  //获取用户组列表
  const fetchUsergroupList = async () => {
    const resp = await UserGroupApi.list({} as unknown as UserGroupDataType);
    if (resp.code === 0 && resp.successful) {
      // 排除注册会员
      const _userGroupList = resp.result.filter((item) => item.groupLevel != 10);
      _userGroupList.forEach((item: UserGroupDataType) => userLevelMap.set(item.uuid as string, item));
      // setUserGroupList(_userGroupList);
      // handleloading(false);
      // console.log("userInfo", _userInfo);
      console.log('userGroupList', _userGroupList);
      return _userGroupList;
    }
  };
  const fetchUsergroupListQuery = useQuery({
    queryKey: ['fetchUsergroupList'],
    queryFn: () => {
      return fetchUsergroupList();
    },
  });
  // 请求数据
  useEffect(() => {
    getBrowserFinger().then((data) => {
      UserApi.getByBrowserFinger(data).then((userResult) => {
        if (userResult.successful) {
          // 设置登录用户详情(已增强)
          const _userPolyInfo = userResult.result as UserPolyInfoDT;
          setItemWithExpiration('userPolyInfo', _userPolyInfo, ApiCachedSecondsRandom);
          updateUserPolyInfo(_userPolyInfo);
          // 设置登录用户
          // user = userResult.result;
          // setItemWithExpiration("user", userResult.result, ApiCachedSecondsRandom);
          // fetchUser(userResult.result.uuid);
          // handleloading(false);
        } else {
          navigate('/login');
        }
      });
    });
  }, []);

  // 修改导航
  useEffect(() => {
    updateNavShowState((draft) => {
      draft.showBottomNav = true;
      draft.showTop1Nav = false;
      draft.showTop2Nav = false;
      draft.showTitleNav = true;
    });
  }, []);

  // 页面内容
  return (
    <>
      {/* 用户信息 */}
      <div
        className={[
          // ' sticky top-10 z-10',
          ' bg-gradient-to-b from-purple-500/90 to-pink-400/80 bg-white',
          ' text-white p-2 rounded-t-none rounded-3xl shadow-lg shadow-white',
        ].join(' ')}
      >
        <UserInfo
          avatar={img.avatar}
          username={userPolyInfo?.asUser.username || '匿名游客'}
          usergroupName={userPolyInfo?.vipList[0]?.usergroupName || '普通用戶'}
          usergroupRemainTime={
            userPolyInfo?.vipList.length == 0 || !userPolyInfo?.vipList
              ? '已过期'
              : date2DurationStr(new Date(), localDatetime2Date(userPolyInfo?.vipList[0]?.usergroupFinishTime))
          }
        />
      </div>

      {/* 温馨提示 */}
      <div
        style={{
          border: '2px solid #f333',
          color: '#f33',
          padding: 10,
          textAlign: 'left',
          lineHeight: 1.5,
        }}
        className=" m-4 bg-slate-100/60 shadow-md rounded-xl"
      >
        {t('user.index.863805-3')}
        <br />
        {t('user.index.863805-4')}
        <br />
        {t('user.index.863805-5')}
      </div>

      {/* 交互按钮 */}
      <div className=" m-4 ">
        <UserOptBar
          userPageIndex={activePanelIndex}
          setUserPageIndex={(activePanelIndex) => {
            setActivePanelIndex(activePanelIndex);
            swiperRef.current.swipeTo(activePanelIndex);
          }}
        />
      </div>

      {/* 展示内容 */}
      <div>
        <Swiper
          ref={swiperRef}
          defaultIndex={0}
          tabIndex={activePanelIndex}
          indicator={(total, current) => <></>}
          onIndexChange={(index) => {
            setActivePanelIndex(index);
          }}
        >
          <Swiper.Item className=" px-4">
            <>
              {!fetchUsergroupListQuery.data ? (
                <>
                  <div className=" mx-4 h-96">
                    <div
                      style={{
                        borderRadius: 20,
                        background: '#ccc',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {/* <Mask visible={loading}> */}
                      <p style={{ color: '#fff', fontSize: 18 }}>
                        {t('user.index.863805-6')}
                        <DotLoading
                          color="#fff"
                          style={{ fontSize: 18 }}
                        />
                      </p>
                      {/* <SpinLoading style={{ "--size": "48px", "--color": "#fff" }} /> */}
                      {/* </Mask> */}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <UserCenter
                    userPolyInfo={userPolyInfo}
                    userGroupList={fetchUsergroupListQuery.data}
                    userPageIndex={activePanelIndex}
                    setUserPageIndex={setActivePanelIndex}
                  />
                </>
              )}
            </>
          </Swiper.Item>
          <Swiper.Item className=" px-4">
            <UserCollect
              collectListId={userPolyInfo?.videoListDtoList.find((item) => item.listType === 'collect').uuid}
            />
          </Swiper.Item>
          <Swiper.Item className=" px-4">
            <UserHistory
              historyListId={userPolyInfo?.videoListDtoList.find((item) => item.listType === 'history').uuid}
            />
          </Swiper.Item>
          <Swiper.Item className=" px-4">
            <UserFeedback userId={userPolyInfo?.asUser.uuid} />
          </Swiper.Item>
          <Swiper.Item className=" px-4">
            <UserSetting
              userInfo={userPolyInfo as UserPolyInfoDT}
              onBindEmail={(email) => {
                if (userPolyInfo != null) {
                  updateUserPolyInfo((draft) => (draft.asUserDetail.userEmail = email));
                }
              }}
              onBindPhone={(phone) => {
                if (userPolyInfo != null) {
                  updateUserPolyInfo((draft) => (draft.asUserDetail.userPhone = phone));
                }
              }}
            />
          </Swiper.Item>
        </Swiper>
        {/* <UserPage /> */}
      </div>
    </>
  );
};

export default Mine;
